import styled from 'styled-components/macro';

export const NoMatchSection = styled.div`
  padding: 50px 50px 200px 50px;
  overflow-y: scroll;
  height: 100%;
`;

export const DescriptionHeader = styled.p`
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0px;
  text-align: center;
  color: #333333;
  margin-bottom: 20px;
`;

export const ResultRow = styled.div`
  color: #000;
  cursor: pointer;
  border-bottom: 0.1rem solid #d8e8ef;
  text-align: left;
  padding: 15px 0px;
  line-height: 1.42857;
  vertical-align: top;
  font-weight: 300;
  width: 100%;
  &:hover {
    color: #7f7f7f;
  }
`;

ResultRow.displayName = 'ResultRow';

export const Heading = styled.span`
  font-family: 'Lato-Bold', sans-serif;
  font-weight: 700;
`;

export const SubHeading = styled.p`
  font-family: 'Lato-Bold', sans-serif;
  font-weight: 700;
  margin: 50px 0px 20px;
  color: #303030;
`;

export const NoMatchInfo = styled.div`
  text-align: left;
  padding: 10px 0px;
  color: #303030;
`;
